import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1About() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-1662">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1663">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-1664">
          <SectionHeading title="Cine sunt eu și de ce facem această muncă împreună" centered={true} data-id="element-1665" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-1666">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-1667">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-1668" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-1669" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-1670" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-1671">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1672" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-1673">
            <div className="hidden lg:block" data-id="element-1674">
              <SectionHeading title="Cine sunt eu și de ce facem această muncă împreună" centered={false} data-id="element-1675" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-1676">
              <p data-id="element-1677">
                Sunt <strong data-id="element-1678">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® certificat de Theta Healing® Institute of
                Knowledge din SUA și Facilitator Heal Your Life după metoda
                Louise Hay. Lucrez în terapii complementare de peste 25 de ani.
              </p>
              <p data-id="element-1679">
                Am ales să fac muncă 1 la 1 pentru că am văzut un lucru clar:
                cursurile dau cunoaștere și inspirație, dar transformările cele
                mai profunde se întâmplă într-un spațiu în care cineva te ține
                de mână și lucrează direct cu tine. Mulți cursanți mi-au spus
                același lucru: „Am citit cărțile, am făcut cursurile, dar abia
                într-o ședință 1 la 1 am simțit cum se schimbă ceva în mine cu
                adevărat."
              </p>
              <p data-id="element-1680">
                În ședințele individuale lucrez cu mare grijă și deschidere.
                Spațiul pe care îl creez este sigur, cald și fără judecată. Tu
                te poți deschide la fel de mult sau de puțin pe cât te simți
                pregătit/ă, iar ritmul este al tău.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-1681">
                Lucrez cu intuiție, experiență și multă iubire. Iar ceea ce
                cursanții îmi spun cel mai des este că simt schimbarea imediat —
                atât în corp, cât și în starea interioară.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-1682">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-1683">
                  "Ședințele 1 la 1 nu sunt despre tehnică. Sunt despre tine.
                  Tehnica e doar instrumentul."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-1684" />
          </motion.div>
        </div>
      </div>
    </section>;
}